var new_date = new Date(
  new Date().setDate(new Date().getDate() + 30)
).toLocaleDateString('it');
const siteTitle = 'Concludi il tuo ordine';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Compila le tue informazioni',
    formTitle2: 'Si paga qui',
    btnForm: 'Continua',
    btnForm2: 'Paga',
    priceText1: 'Pagamento',
    priceText2: 'Totale',
    footerTitle: 'Pagamento online',
    footerText: 'Conferma con la tua carta di credito',
    shippingInfoText: 'Informazioni di spedizione e fatturazione',
    paymentInfoText: 'INFORMAZIONI DI PAGAMENTO',
    agreengText:
      'Cliccando su "Continua", confermo di aver letto, acconsentito e accettato i Termini e Condizioni, la Politica sulla Privacy, e di avere almeno 18 anni.',
    checkboxText:
      'Accetto di ricevere notifiche di newsletter, offerte e servizi di comunicazione.',
    bigFooterText: `Grazie alla tua iscrizione, partecipi anche al nostro concorso per vincere ${siteTitle}. Selezioniamo un vincitore tra ogni 600 partecipanti. Il prossimo vincitore sarà selezionato il ${new_date} e verrà avvisato direttamente tramite e-mail. Se il premio è esaurito, il vincitore riceverà invece un prodotto simile di valore uguale o superiore.`,
    bigFooterText1: `Ci assicuriamo che ai nostri membri venga fornita una cronologia dettagliata delle transazioni e per questo sappiano per cosa stanno pagando. I dati della carta di credito sono richiesti solo per facilitare gli acquisti futuri. Non ci saranno addebiti sull'estratto conto della tua carta di credito se non passi all'abbonamento PREMIUM e non effettui un acquisto.`,
    bigFooterText2: `Aderendo a questo servizio, riceverai una prova di 5 giorni del programma del nostro partner. Se prosegui con l'abbonamento oltre i 5 giorni di prova, ti verrà addebitato sulla tua carta di credito un importo che varia a seconda della tariffa scelta. Quando il tuo contributo verrà detratto dalla tua carta di credito o da un altro metodo di pagamento, avrai accesso a questi servizi riservati esclusivamente ai membri del sito web del nostro partner.`,
    subtotalText: 'Subtotale',
    amountText: 'Importo da pagare',
    shippingText: 'Spedizione',
    totalText: 'Totale',
    freeText: 'Gratuito',
    countryLabel: 'Paese',
    country: 'Italia',
  },
  home: {
    placeholder: {
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      city: 'Città',
      address: 'Indirizzo',
      zip: 'Codice postale',
      continue: 'Continuare',
      name: 'Name',
    },
    confirmPayment: 'Conferma il pagamento',
    cardNumber: 'numero della carta',
    expirationDate: 'data di scadenza',
    name: 'conome',
    month: 'mese',
    year: 'anno',
    cvv: 'CVV',
    timer: `Tempo residuo fino al pagamento dell'ordine`,
    labelNumber: 'Il numero della carta:',
    labelMonth: 'Data di scadenza:',
    source:
      'Utilizziamo la sicurezza 3D per verificare il tuo acquisto. Potrebbe apparire una nuova finestra di verifica della transazione',
  },
  validation: {
    requireEmail: 'La tua email è vuota',
    validEmail: "L'email non è valida",
    requirePhone: 'Il tuo telefono è vuoto',
    minPhone: 'Il campo del telefono deve contenere almeno 10 caratteri.',
    requireFirstName: 'Il nome è obbligatorio.',
    validFirstName: 'Il primo nome non è valido.',
    requireLastName: 'È richiesto il campo del cognome.',
    validLastName: 'Le champ Nom de famille est obligatoire.',
    requireCity: 'Le champ ville est obligatoire.',
    validCity: 'Il campo della città non è valido.',
    requireAddress: "Il campo dell'indirizzo è obbligatorio.",
    validAddress: "Il campo dell'indirizzo non è valido.",
    requireZip: 'Il campo del codice postale è obbligatorio.',
    validZip: 'Il campo zip non è valido.',
    requireCard: 'Il campo del numero di carta è richiesto.',
    minCard: 'Non abbastanza simboli.',
    validCard: 'Il campo del numero di carta non è valido.',
    requireMonth: 'Il campo del mese di scadenza è obbligatorio.',
    requireYear: 'Il campo Anno di scadenza è obbligatorio.',
    requireName: 'È richiesto il campo nome.',
    validName: 'Il campo del nome non è valido.',
    requireCvv: 'Il campo cvv è obbligatorio.',
    validCvv: 'Il campo cvv non è valido.',
    minFirstName: 'Il campo del nome deve contenere almeno 3 caratteri.',
    minLastName: 'Il campo del cognome deve contenere almeno 3 caratteri.',
    minCity: 'Il campo della città deve contenere almeno 3 caratteri.',
    minAddress: "Il campo dell'indirizzo deve essere di almeno 3 caratteri.",
    minZip: 'Il campo del codice postale deve contenere almeno 3 caratteri.',
    minName: 'Il campo del nome deve contenere almeno 3 caratteri.',
    minCvv: 'Il campo cvv deve avere almeno 3 caratteri.',
    specialFirstName: 'Il nome del campo non deve contenere caratteri speciali',
    specialLastName:
      'Il cognome del campo non deve contenere caratteri speciali',
    specialName: 'Il nome del campo non deve contenere caratteri speciali',
    specialCity: 'Il campo city non deve contenere caratteri speciali',
  },
  mask: {
    phone: '+3\\9 999 999 999',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'RICEVI IN TOCCO',
    firstName: 'Nome di battesimo',
    lastName: 'Cognome',
    email: 'E-mail',
    msg: 'Messaggio',
    send: 'Inviare',
    alreadyRegistered: 'Sei già registrato',
    unsubscribeLink: 'Sei già registrato',
    worktime: 'Call center Funziona dalle 10 alle 17',
    phone: 'Telefono: Sofia +359 2 437 4207',
  },
  footer: {
    title: 'Partecipa prima che sia troppo tardi',
    terms: 'Termini e condizioni',
    privacy: 'Informativa sulla privacy',
    contact: {
      title: 'Contattaci',
      text: 'Ci impegniamo a fornire a ciascuno dei nostri preziosi clienti un eccellente servizio clienti. Se hai domande o dubbi, non esitare a contattare uno dei nostri rappresentanti del servizio clienti professionale',
    },
  },
};
